import { useState } from "react";
import { MapPin, CheckCircle2, XCircle } from "lucide-react";
import { http, errMsg } from "../lib/api";

export const PincodeChecker = () => {
  const [pin, setPin] = useState(() => localStorage.getItem("hw_pin") || "");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const check = async (e) => {
    e.preventDefault();
    setLoading(true); setError(""); setResult(null);
    try {
      const { data } = await http.post("/pincode/check", { pincode: pin });
      setResult(data);
      localStorage.setItem("hw_pin", pin);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="pincode-checker" className="rounded-md border border-border bg-card p-5">
      <p className="flex items-center gap-2 text-sm font-semibold"><MapPin className="h-4 w-4" /> Check delivery to your Hyderabad home</p>
      <form onSubmit={check} className="mt-3 flex gap-2">
        <input
          data-testid="pincode-check-input" inputMode="numeric" maxLength={6} value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} placeholder="Hyderabad PIN code, e.g. 500032"
          className="h-11 flex-1 rounded-full border border-input bg-background px-4 text-sm outline-none focus:border-brass"
        />
        <button data-testid="pincode-check-button" disabled={pin.length !== 6 || loading} className="btn-outline px-5 py-2">{loading ? "Checking" : "Check"}</button>
      </form>
      {result?.serviceable && (
        <p data-testid="pincode-check-result" className="mt-3 flex items-start gap-2 text-sm text-neem dark:text-jute">
          <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" />
          <span><b>{result.message}.</b> Arrives between {result.from_date} and {result.to_date}.</span>
        </p>
      )}
      {result && !result.serviceable && (
        <p data-testid="pincode-check-result" className="mt-3 flex items-start gap-2 text-sm text-destructive"><XCircle className="mt-0.5 h-4 w-4 shrink-0" />{result.message}</p>
      )}
      {error && <p data-testid="pincode-check-error" className="mt-3 text-sm text-destructive">{error}</p>}
    </div>
  );
};
